<template>
  <div>
    <v-dialog v-model="value" max-width="80%" persistent scrollable>
      <v-card>
        <v-card-title class="headline gradiente lighten-2 elevation-3">
          <span class="white--text">Confirmación de lectura</span>
        </v-card-title>
        <v-card-text>
          <v-layout row wrap>
            <v-flex xs12>
              <v-text-field
                @input="filterSearch"
                class="mx-3"
                flat
                label="Buscar"
                prepend-inner-icon="search"
                solo-inverted
                clearable
              ></v-text-field>
            </v-flex>
            <v-flex xs12>
              <v-data-table
                :headers="headers"
                :items="notice.watchedByParents"
                :custom-filter="customFilter"
                no-data-text="No hay tutores"
                :rows-per-page-items="[10, 15, 25]"
                rows-per-page-text="Registros por página"
                no-results-text="No hay coincidencias"
                :search="filters"
                item-key="parent.id"
                ref="table"
              >
                <template
                  v-slot:pageText="props"
                >{{ props.pageStart }} - {{ props.pageStop }} de {{ props.itemsLength }}</template>
                <template v-slot:headers="props">
                  <th v-for="header in props.headers" :key="header.text">{{ header.text }}</th>
                </template>
                <template v-slot:items="props">
                  <td
                    class="text-xs-center"
                    style="width: 426px; max-width: 426px; min-width: 426px;"
                  >
                    <v-avatar
                      :tile="tile"
                      :size="avatarSize"
                      color="grey lighten-4"
                      v-if="props.item.imageStorage && props.item.imageStorage.miniObjUrl"
                    >
                      <img :src="props.item.imageStorage.miniObjUrl" alt="avatar" />
                    </v-avatar>
                    <v-avatar v-else text-color="white">
                      <v-icon>account_circle</v-icon>
                    </v-avatar>
                  </td>
                  <td class="text-xs-center">{{ props.item.firstName + " "+ props.item.lastName }}</td>
                  <td class="text-xs-center">{{ props.item.mail}}</td>
                </template>
              </v-data-table>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn flat color="primary" @click="close">Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  props: ["value", "notice"],
  data: () => ({
    avatarSize: "30px",
    filters: {
      search: ""
    },
    headers: [
      {
        text: "Foto",
        align: "center",
        value: "image"
      },
      {
        text: "Tutor",
        align: "center",
        value: "firstName"
      },
      { text: "Correo", align: "center", value: "mail" }
    ]
  }),

  methods: {
    close() {
      this.$emit("input", !this.value);
    },
    customFilter(items, filters, filter, headers) {
      const cf = new this.$MultiFilters(items, filters, filter, headers);

      cf.registerFilter("search", function(searchWord, items) {
        if (searchWord == null) return items;

        return items.filter(item => {
          return (
            item.firstName.includes(searchWord.toLowerCase()) ||
            item.lastName.includes(searchWord.toLowerCase()) ||
            item.mail.includes(searchWord.toLowerCase())
          );
        }, searchWord);
      });
      return cf.runFilters();
    },
    filterSearch(val) {
      this.filters = this.$MultiFilters.updateFilters(this.filters, {
        search: val
      });
    }
  }
};
</script>
<style>
.titleSearch .v-input .v-text-field .v-input__slot {
  border-radius: 33px !important;
}
</style>
<style scoped>
td,
th {
  width: 426px;
  max-width: 426px;
  min-width: 426px;
}
</style>